import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton"]

  connect () {
    this.toggleClearButton()
  }

  clear (event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.toggleClearButton()
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  toggleClearButton () {
    if (!this.hasClearButtonTarget) return

    this.clearButtonTarget.hidden = this.inputTarget.value.length === 0
  }
}
